<template lang="pug">
.card.mb-0
  .card-header
    .row.w-100      
      .form-group.col-md-3.col-2.mb-1
        b-input-group(size="sm")
          b-input-group-text(slot="prepend")
            span {{ $t('ui.status') }}
          b-form-select(v-model="newsStatus" @change="getNewsList(true)" :disabled="loading" size="sm")
            option(value=0) {{ $t('ui.all') }}
            option(value=1) {{ $t('ui.active') }}
            option(value=-1) {{ $t('ui.inactive') }}
      //- Page name search reserved for future use.
      //- .form-group.col-md-3.col-2.mb-1
      //-   b-input-group(size="sm")
      //-     b-input-group-text(slot="prepend")
      //-       i.fa.fa-search
      //-     DebounceInput(type="text" v-model="pageName" :placeholder="$t('ui.page_name')" @enter="getNewsList(true)" size="sm")
      //- .form-group.col-md-6.col-8.mb-1
      //-   SubmitButton(
      //-     :loading="loading"
      //-     icon="fa fa-search"
      //-     :text="$t('ui.search')"
      //-     type="button"
      //-     @click="getNewsList(true)"
      //-     variant="primary"
      //-     size="sm"
      //-   )
      .form-group.col-12.mb-1(v-if="isEditAccess")
        b-button(v-b-modal.addNews type="button" variant="info" size="sm")
          i.fa.fa-plus
          span.ml-1 {{ $t("ui.combine.add_news") }}
  .card-body
    .row
      .col-10.mb-1
        b-pagination.float-left(
          size="sm"
          hide-ellipsis
          :total-rows="totalRow"
          :per-page="getPageSize"
          v-model="currentPage"
          @input="changedPage($event)"
        )
      .col-2.mb-1
        b-input-group(:prepend="$t('ui.page_size')" size="sm")
          b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")              
      .col-12
        .clusterize-scroll.table-responsive
          table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
            thead.thead-light
              tr
                th.text-center(width="3%")
                  span #
                th(width="10%" @click="sortOrder('slug')")
                  span(:title="$t('ui.slug')") {{ $t("ui.slug") }}
                  .float-right
                    i(:class="changeSortKey('slug')")
                th(width="10%" @click="sortOrder('en_title')")
                  span(:title="$t('ui.en_title')") {{ $t("ui.en_title") }}
                  .float-right
                    i(:class="changeSortKey('en_title')")
                th(width="10%")
                  span(:title="$t('ui.cn_title')") {{ $t("ui.cn_title") }}
                th(width="10%")
                  span(:title="$t('ui.local_title')") {{ $t("ui.local_title") }}
                th(width="10%")
                  span(:title="$t('ui.en_img')") {{ $t("ui.en_img") }}
                th(width="10%")
                  span(:title="$t('ui.cn_img')") {{ $t("ui.cn_img") }}
                th(width="10%")
                  span(:title="$t('ui.local_img')") {{ $t("ui.local_img") }}
                th.text-center(width="7%")
                  span(:title="$t('ui.status')") {{ $t("ui.status") }}
                th.text-center(width="10%" v-if="isEditAccess")
                  span(:title="$t('ui.action')") {{ $t("ui.action") }}
                th.text-right(width="10%")
                  span(:title="$t('ui.created_date')") {{ $t("ui.created_date") }}
            tbody.clusterize-content
              tr(v-if="newsList.length == 0")
                td(:colspan="isEditAccess ? '10' : '9'").text-center
                  span {{ $t('message.no_data_available') }}
              tr(
                v-for="(item, index) in newsList"
                draggable="true"
                @dragstart="handleDragStart($event, index)"
                @dragover.prevent
                @dragenter="handleDragEnter($event, index)"
                @dragleave="handleDragLeave"
                @drop="handleDrop($event, index)"
                @dragend="handleDragEnd"
                :id="item.id"
              )
                td.text-center
                  span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                td
                  span.small(:title="item.slug" v-html="item.slug")
                td.grabbable
                  span.small(:title="item.en_title" v-html="item.en_title")
                td
                  span.small(:title="item.cn_title" v-html="item.cn_title")
                td
                  span.small(:title="item.local_title" v-html="item.local_title")
                td
                  span(v-if="item.en_image_url")
                    b-img.fiximg(:src="getImgPath(item.en_image_url)" @error="handleImageError")
                td
                  span(v-if="item.cn_image_url")
                    b-img.fiximg(:src="getImgPath(item.cn_image_url)" @error="handleImageError")
                td
                  span(v-if="item.local_image_url")
                    b-img.fiximg(:src="getImgPath(item.local_image_url)" @error="handleImageError")
                td
                  div.d-flex.justify-content-center.align-items-center
                    label.custom-switch
                      input.custom-switch-input(type='checkbox' name='custom-switch-checkbox' v-model="item.status" @change="changedNewsStatus(item, $event)" :disabled="!isEditAccess")
                      span.custom-switch-indicator
                td.text-center(v-if="isEditAccess")
                  span
                    a.fa.fa-edit.btn.btn-ssm.btn-icon.btn-primary(href="javascript:void(0)" @click="onEdit(item)" :title="$t('ui.edit')")
                  span.ml-1
                    a.fa.fa-trash.btn.btn-ssm.btn-icon.btn-danger(href="javascript:void(0)" @click="onDelete(item)" :title="$t('ui.delete')")
                td.text-right
                  span(:title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}
  addnews(@clicked="addNews" @failed="handleFailed")
  editnews(ref="editnews" :item="editSelectedNews" @clicked="afterEditNews" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import addnews from "@/components/cms/addNews.vue";
import editnews from "@/components/cms/editNews.vue";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    addnews,
    editnews
  },
  props: {
    currTab: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    loading: false,
    newsList: [],
    currentPage: 1,
    totalRow: 0,
    sortKey: "item_order",
    sortType: "asc",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    editSelectedNews: null,
    newsStatus: 1,
    // pageName: "", // Reserved for future use.
    imagePath: config.viewImageUrl
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSizeCms;
    },
    accountType() {
      return this.$store.getters.accountType;
    },
    isAdmin() {
      return this.$store.getters.accountType === 5;
    },
    isAdminMaster() {
      return [3,5].includes(this.$store.getters.accountType);
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    loginId() {
      return this.$store.getters.loginId;
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
    isEditAccess() {
      return this.$helpers.showActionButton("e_cms");
    }
  },
  mounted: function() {
    // this.getNewsList(true);
  },
  methods: {
    getImgPath: function(img) {
      // const url = new URL(img); 
      const url = URL.parse(img);
      if (url != null && url.protocol === "https:") {
        return img
      } else {
        return this.imagePath + img
      }
    },
    refresh() {
      this.getNewsList(true);
    },
    handleImageError(event) {
      // event.target.src = 'https://via.placeholder.com/150?text=No+Image'; // Set fallback image
      event.target.src = 'https://placehold.co/150?text=No+Image'; // Set fallback image
    },
    handleDragStart(e, index) {
      // console.log("handleDragStart", e.target.id)
      this.dragSrcIndex = index;
      e.dataTransfer.effectAllowed = 'move';
      e.dataTransfer.setData('text/plain', index);
      e.target.classList.add('dragging');
    },
    handleDragEnter(e, index) {
      e.target.parentElement.classList.add('over');
      // e.target.classList.add('over');
    },
    handleDragLeave(e) {
      e.target.parentElement.classList.remove('over');
      // e.target.classList.remove('over');
    },
    handleDrop(e, index) {
      e.stopPropagation();
      e.target.parentElement.classList.remove('over');
      // e.target.classList.remove('over');

      const dragSrcIndex = this.dragSrcIndex;
      // console.log("handleDrop", dragSrcIndex, index)
      if (dragSrcIndex !== index) {
        const draggedItem = this.newsList[dragSrcIndex];
        const targetItem = this.newsList[index];
        // console.log("draggedItem", draggedItem.vip_id, targetItem.item_order)
        if(this.isEditAccess)
          this.confirmNewsMove(draggedItem.id, draggedItem.en_title, targetItem.item_order);
      }

      e.target.classList.remove('dragging');
    },
    handleDragEnd(e) {
      e.target.classList.remove('dragging');
    },
    confirmNewsMove: function(newsID, enTitle, itemOrder) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.move_news_confirm", { name: enTitle, position: itemOrder }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.newsMove(newsID, itemOrder);
          } else {
            this.getNewsList();
          }
        });
    },
    newsMove: function(newsID, itemOrder) {
      let url = config.cmsNewsMoveUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        news_id: newsID,
        item_order: itemOrder
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getNewsList();
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }

      this.getNewsList(true);
    },
    changeSortKey(key, type) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    afterEditNews: function(item) {
      this.getNewsList();
      this.$helpers.showDialog(this.$t("ui.combine.edit_news"), this.$t("message.success"), "success");
    },
    onEdit(e) {
      this.editSelectedNews = e;
      this.$refs.editnews.$refs.editNews.show();
    },
    onDelete: function(item) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.delete_news_confirm", { name: item.id }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmNewsDelete(item);
          }
        });
    },
    confirmNewsDelete: function(item) {
      let url = config.cmsNewsDeleteUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        news_id: item.id
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                // item.status = status;
                this.getNewsList();
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getNewsList: function(isSearch) {
      let url = config.cmsNewsListUrl();

      if (isSearch) this.currentPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        sort_type: this.sortType,
        page_number: this.currentPage,
        page_size: this.getPageSize,
      };

      // if (this.pageName) json.page_name = this.pageName;

      if (this.newsStatus == 1) {
        json.news_status = true;
      } else if (this.newsStatus == -1) {
        json.news_status = false;
      }

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.newsList = response.data.dt;
                this.totalRow = this.newsList.length > 0 ? this.newsList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedNewsStatus: function(item, eventStatus) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.change_news_status_confirm", { name: item.id }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmNewsStatus(item, eventStatus.srcElement.checked);
          } else {
            eventStatus.srcElement.checked = !item.status;
            item.status = !item.status;
          }
        });
    },
    confirmNewsStatus: function(item, status) {
      let url = config.cmsNewsStatusUpdateUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        news_id: item.id,
        new_status: status
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                // item.status = status;
                this.getNewsList();
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                this.getNewsList();
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    onUpDown: function(item, isUp) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.move_news_" + (isUp == true ? 'up' : 'down') + "_confirm", { name: item.id }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmNewsUpDown(item, isUp);
          }
        });
    },
    confirmNewsUpDown: function(item, isUp) {
      let url = config.cmsNewsUpDownUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        news_id: item.id,
        direction: isUp
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                // item.status = status;
                this.getNewsList();
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    addNews: function() {
      this.getNewsList(true);
      this.$helpers.showDialog(this.$t("ui.combine.add_news"), this.$t("message.success"), "success");
    },
    changedPageSize: function(pageSize) {
      if(this.currTab != 'news') return
      this.$store.dispatch("layout/setPageSizeCms", pageSize);
      this.currentPage = 1;
      this.getNewsList(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getNewsList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
<style lang="scss" scoped>
.fiximg {
  height:40px; 
  width:100%;
}

hr {
  margin-top:0em !important;
  margin-bottom:0em !important;
  width: 50% !important;
}

.blink {
  -webkit-animation: blinking 1.5s ease infinite; /* Safari 4+ */
  -moz-animation: blinking 1.5s ease infinite; /* Fx 5+ */
  -o-animation: blinking 1.5s ease infinite; /* Opera 12+ */
  animation: blinking 1.5s ease infinite; /* IE 10+, Fx 29+ */
}

.red-bg {
  background-color: lightcoral !important
}

td {
  vertical-align: middle !important;
}

.selectable-text {
  user-select: text;
}
</style>